export default "__VITE_ASSET__DL0olXLG__"